import SectionHeading from './SectionHeading'
import FirstIcon from '../../Icons/HomePage/service/new-services/1.svg'
import SecondIcon from '../../Icons/HomePage/service/new-services/2.svg'
import ThirdIcon from '../../Icons/HomePage/service/new-services/3.svg'
// Removed unused: FourthIcon, FifthIcon
// import SixthIcon from '../../Icons/HomePage/service/new-services/6.svg'
import SectionSubText from './SectionSubText'
import BookACallButton from '../Buttons/Specials/BookACallButton'

const WithCoaches = ({ children }) => {
    return (
        <div
            className="pb-28"
            style={{
                backgroundImage: "url('/assets/homepage/service/bg.svg')",
                backgroundPosition: 'bottom center',
                backgroundRepeat: 'no-repeat',
            }}>
            <ServicesWrapper>
                {children}
                <div className="py-16 mt-14 md:mt-32 mx-4 -mb-48 px-3 sm:px-12 md:px-24 max-w-7xl my-12 olm-gradient rounded-xl md:rounded-lg md:mx-auto">
                    <div className="flex flex-col md:flex-row w-full">
                        <div className="w-full md:w-3/12 text-center md:text-left mb-8 md:mb-0">
                            <h2 className="text-4xl md:text-5xl font-bold text-white">
                                Meet Your <br className="hidden md:block" />
                                Coaches
                            </h2>
                            <div className="mt-8 w-68 hidden md:block">
                                <BookACallButton scheme="white" />
                            </div>
                        </div>
                        <div className="md:flex w-full md:w-9/12 flex-wrap md:flex-row space-x-2 md:space-x-6 items-center justify-center">
                            {coaches.map((coach, index) => (
                                <div
                                    key={index}
                                    className="text-center mb-8 md:mb-0">
                                    <img
                                        src={coach.image}
                                        alt={coach.alt}
                                        title={coach.title}
                                        className="w-48 h-48 rounded-full mx-auto bg-white"
                                    />
                                    <h3 className="mt-4 text-white text-xl font-semibold">
                                        {coach.name}
                                    </h3>
                                </div>
                            ))}
                        </div>
                        <div className="mt-8 md:hidden mx-auto w-full">
                            <BookACallButton scheme="white" />
                        </div>
                    </div>
                </div>
            </ServicesWrapper>
        </div>
    )
}

const ServicesWrapper = ({ children }) => {
    return (
        <div className="py-16 bg-light-yellow-gradient rounded-4xl md:rounded-8xl">
            {children}
        </div>
    )
}

const ServicesCards = ({ heading }) => {
    return (
        <>
            <div className="text-center mb-16 px-4">
                <SectionHeading>{heading}</SectionHeading>
                <SectionSubText>
                    <h2 className="font-bold">
                        {' '}
                        Direct Mail That Fills Your Pipeline
                    </h2>
                    We don’t just send mail — we build targeted, data-driven
                    campaigns that generate seller leads for real estate pros
                    and booked estimates for home service businesses. Here’s how
                    we help you win:
                </SectionSubText>
            </div>

            <div className="max-w-7xl mx-auto px-4 flex flex-wrap gap-6 justify-center">
                {services.map((Service, index) => (
                    <div
                        key={index}
                        className="bg-white p-6 rounded-lg border text-center w-full sm:w-1/2 lg:w-[30%]">
                        <div className="mb-8 text-center justify-center flex">
                            <Service.Icon />
                        </div>
                        <h3 className="text-xl font-semibold text-olm-black mb-2">
                            {Service.title}
                        </h3>
                        <p className="text-olm-new-black">
                            {Service.description}
                        </p>
                    </div>
                ))}
            </div>
        </>
    )
}

function OurServices({
    showCoaches = true,
    heading = <span className="olm-gradient-text">Our Services</span>,
}) {
    return showCoaches ? (
        <WithCoaches>
            <ServicesCards heading={heading} />
        </WithCoaches>
    ) : (
        <ServicesWrapper>
            <ServicesCards heading={heading} />
        </ServicesWrapper>
    )
}

const services = [
    {
        Icon: FirstIcon,
        title: 'Marketing Coaches',
        description:
            'One-on-one customer service support from a dedicated coach who learns your goals, audits your campaigns, and gives you clear next steps.',
    },
    {
        Icon: SecondIcon,
        title: 'High-Impact Graphic Design',
        description:
            'Our in-house Graphic Design team is highly skilled at making your brand pop—polished layouts, on-brand typography, and creative that gets noticed (and acted on).',
    },
    {
        Icon: ThirdIcon,
        title: 'Advanced List Building',
        description:
            'We bring the data. We build and stack lists to reach the right recipients at the moments they’re most likely to act—maximizing response and ROI.',
    },
    // Removed: Performance Tracking, Insightful Content
]

const coaches = [
    {
        name: 'Jake Soper',
        image: '/assets/homepage/jake-soper.png',
        alt: 'Jake Soper image',
        title: 'Book a One-on-one call with our coach Jake Soper',
    },
    {
        name: 'Jenn Brown',
        image: '/assets/homepage/jenn-brown.png',
        alt: 'Jenn Brown image',
        title: 'Book a One-on-one call with our coach Jenn Brown',
    },
    {
        name: 'Adrian',
        image: '/assets/homepage/adrian.png',
        alt: 'Adrian image',
        title: 'Book a One-on-one call with our coach Adrian',
    },
]

export default OurServices
